// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1ZfBl","footer":"ModalInfo_footer__1UOHH"};